import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import ContextLoading from '../Loading'

import { Footer } from './styles'
import logo from './logo.png'
import { setLanguage } from '../../config/i18n'
import Contact from '../Contact'

const telephones = [
  { hq: 'San Francisco (US)', tel: '+1 415 851 2845' },
  { hq: 'São Paulo (BR)', tel: '+55 71 99378 9889' },
]
const social = [
  { name: 'Instagram', href: 'https://www.instagram.com/r2u.io' },
  { name: 'Facebook', href: 'https://www.facebook.com/r2u.io' },
  { name: 'LinkedIn', href: 'https://www.linkedin.com/company/r2u-io' },
  { name: 'Medium', href: 'https://medium.com/r2u' },
]

export default function () {
  const { t, ready } = useTranslation(['components/footer'])
  const [isContactOpen, setIsContactOpen] = useState(false)

  return (
    <ContextLoading isLoading={!ready}>
      <div>
        <Contact isOpen={isContactOpen} setIsOpen={setIsContactOpen} />
        <Footer>
          <div className="left">
            <Link to="/">
              <img src={logo} alt="R2U" />
              <span>{t('r2u')}</span>
              <span>{t('2020')}</span>
            </Link>
            <div className="languages">
              <span>
                {/* eslint-disable react/jsx-no-literals */}
                <button onClick={() => setLanguage('pt-BR')} type="button">
                  PT
                </button>
                {' | '}
                <button onClick={() => setLanguage('en-US')} type="button">
                  EN
                </button>
                {/* eslint-enable react/jsx-no-literals */}
              </span>
            </div>
            <div>
              <button onClick={() => setIsContactOpen(true)} type="button">
                <b>{t('contact')}</b>
              </button>
            </div>
          </div>
          <div className="right">
            <div>
              {/* eslint-disable react/jsx-no-literals */}
              {telephones.map((telephone) => (
                <a
                  key={telephone.tel}
                  className="margin"
                  href={`https://wa.me/${telephone.tel
                    .replace(/\s/g, '')
                    .replace('+', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div>
                    <span>
                      <b>{telephone.hq}</b>
                    </span>
                  </div>
                  <div>
                    <span>{telephone.tel}</span>
                  </div>
                </a>
              ))}
              <a
                className="margin"
                href={`mailto:${t('email')}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>
                  <b>{t('email')}</b>
                </span>
              </a>
              {/* eslint-enable react/jsx-no-literals */}
            </div>
            <div>
              <h4>{t('social')}</h4>
              <div className="social">
                {social.map(({ href, name }) => (
                  <a
                    key={name}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>{name}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </Footer>
      </div>
    </ContextLoading>
  )
}
